import { Component, Input, forwardRef, OnInit, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';

let nextId = 0;

@Component({
  selector: 'ot-radio-group',
  templateUrl: './radio-group.component.html',
  styleUrls: ['./radio-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioGroupComponent),
      multi: true,
    },
  ],
})
export class RadioGroupComponent
  implements ControlValueAccessor, OnInit, OnDestroy
{
  @Input() options: string[] = [];
  @Input() name: string;
  @Input() layout: 'horizontal' | 'vertical' = 'horizontal';
  @Input() placeholder = '';
  @Input() required = false;

  readonly stateChanges = new Subject<void>();
  readonly id = `radio-group-${nextId++}`;

  value: any;
  focused = false;
  empty = true;
  disabled = false;

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {}

  ngOnInit() {
    if (!this.options || this.options.length === 0) {
      this.options = ['Yes', 'No'];
    }
  }

  ngOnDestroy() {
    this.stateChanges.complete();
  }

  onSelect(value: any) {
    if (this.disabled) return;

    this.value = value;
    this.empty = value === null || value === undefined || value === '';
    this.onChange(value);
    this.onTouched();
    this.stateChanges.next();
  }

  isChecked(option: string): boolean {
    return this.value === option;
  }

  writeValue(value: any): void {
    this.value = value;
    this.empty = value === null || value === undefined || value === '';
    this.stateChanges.next();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.stateChanges.next();
  }

  setDescribedByIds(ids: string[]): void {
    // Not needed for this component
  }

  focus(): void {
    this.focused = true;
    this.stateChanges.next();
  }
}
